<router-outlet></router-outlet>
<app-product-tour></app-product-tour>

<!-- Background Watermark -->
<div class="app-watermark">
  <div class="watermark-content">
    <span class="brand">eaze customs</span>
    <span class="env" *ngIf="envName">{{ envName }}</span>
  </div>
</div>
